import { useEffect, useState } from 'react';

// Returns `value` once it has stopped changing for `delayMs`, so typing into a search box
// does not fire a request per keystroke.
export const useDebouncedValue = <T>(value: T, delayMs: number): T => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timeout = setTimeout(() => setDebounced(value), delayMs);
    return (): void => clearTimeout(timeout);
  }, [value, delayMs]);
  return debounced;
};
